module.exports = __webpack_public_path__ + "img/cattedrale_monza_hero_card.a7e7ee47.png";